import axios from '@axios';

export default {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		fetchRequestInformation(ctx, { id }) {
			return new Promise((resolve, reject) => {
				axios
					.get(`/request-information/${id}/edit`)
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
		updateRequestInformation(ctx, { id, payload }) {
			return new Promise((resolve, reject) => {
				axios
					.put(`/request-information/${id}`, payload)
					.then(response => resolve(response))
					.catch(error => reject(error));
			});
		},
	}
}